import React from "react";
import PropTypes from "prop-types";
// import { useHistory } from "react-router-dom";
// import { UserContext } from "context/user";
import CustomModal from "components/Modal";
import Button from "components/Button";
import "./index.scss";

const UploadFileWarningModal = ({ farms, isOpen, onClose, handleSkip }) => {
  const handleOnClose = () => {
    onClose();
  };

  return (
    <CustomModal
      isOpen={isOpen}
      size="medium"
      onClose={handleOnClose}
      onRequestClose={handleOnClose}
    >
      <div className="upload-file-warning">
        <h3 className="title">Uploading Failed</h3>
        {farms && farms[0]?.properties?.name ? (
          <>
            <div className="paragraph">
              We encountered an error and failed to upload your fields. Below
              are the fields that were not able to upload:
            </div>
            <div className="farm-list">
              {farms?.map((farm, i) => (
                <p className="item-list">
                  {i + 1}. {farm?.properties?.name}
                </p>
              ))}
            </div>
          </>
        ) : (
          <>
            <div className="paragraph">
              We encountered an error and failed to upload your fields. Do you
              want to skip these fields and create the farm?
            </div>
          </>
        )}
        <div className="action-list">
          <Button
            type="solid"
            color="green"
            label="Skip these files"
            block
            onClick={handleSkip}
          />
          <Button
            type="solid"
            color="white"
            label="Cancel"
            block
            onClick={handleOnClose}
          />
        </div>
      </div>
    </CustomModal>
  );
};

UploadFileWarningModal.propTypes = {
  farms: PropTypes.shape({
    name: PropTypes.string.isRequired,
    map: PropTypes.string.isRequired,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  handleSkip: PropTypes.func.isRequired,
};

export default UploadFileWarningModal;
